import * as React from 'react';
import cx from 'classnames';

// UI
import { Typography } from '@components/typography';
import { Button } from '@components/button';

type Props = {
  title: string;
  capacity: number;
  maxCapacity: number;
  onCapacityUpdate: React.Dispatch<React.SetStateAction<number>>;
};

export const CapacitySelector: React.FC<Props> = ({
  title,
  capacity,
  maxCapacity,
  onCapacityUpdate,
}) => {
  return (
    <div className="space-y-2">
      <div className="flex flex-row">
        <Typography variant="body1" variantM="body1" component="p">
          {title}
        </Typography>
      </div>

      <div className="space-x-2 overflow-auto whitespace-no-wrap py-2 text-left no-scrollbar overflow-y-auto">
        {Array.from({ length: maxCapacity + 1 }, (_, i) => i).map((number) => (
          <Button
            key={number}
            isCircle={true}
            size={'sm'}
            color="primary"
            variant="outlined"
            onClick={() => {
              onCapacityUpdate(number);
            }}
            className={cx('h-10', 'w-10', 'px-[0.95rem]', 'text-center', {
              'px-2': number === 0,
              'bg-primary-xlight text-primary-dark border-primary-main':
                number === capacity,
              'bg-white text-primary-main border-primary-main hover:bg-primary-xlight hover:text-primary-dark':
                number !== capacity,
            })}
          >
            {number == 0 ? 'Any' : number}
          </Button>
        ))}
      </div>
    </div>
  );
};
